import { riskCategories } from "@/mocks/blacklist";

const LEVELS = [
  { key: "all", label: "全部等级" },
  { key: "high", label: "高危" },
  { key: "mid", label: "中危" },
  { key: "watch", label: "观察" },
];

const SORTS = [
  { key: "updated", label: "最近更新" },
  { key: "complaints", label: "投诉最多" },
  { key: "views", label: "查看最多" },
  { key: "name", label: "名称排序" },
];

interface FilterBarProps {
  keyword: string;
  category: string;
  level: string;
  sort: string;
  resultCount: number;
  onKeywordChange: (value: string) => void;
  onSearchSubmit: () => void;
  onCategoryChange: (value: string) => void;
  onLevelChange: (value: string) => void;
  onSortChange: (value: string) => void;
}

export default function FilterBar({
  keyword,
  category,
  level,
  sort,
  resultCount,
  onKeywordChange,
  onSearchSubmit,
  onCategoryChange,
  onLevelChange,
  onSortChange,
}: FilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onSearchSubmit();
        }}
        role="search"
        className="flex flex-col gap-3 md:flex-row md:items-center"
      >
        <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 transition-colors focus-within:border-primary-400">
          <i className="ri-search-line text-lg text-foreground-500" />
          <input
            type="search"
            value={keyword}
            onChange={(event) => onKeywordChange(event.target.value)}
            placeholder="搜索平台名称、域名或风险标签"
            aria-label="搜索平台名称、域名或风险标签"
            className="w-full bg-transparent font-label text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
        </div>
        <div className="flex items-center gap-2">
          <label htmlFor="sort-select" className="whitespace-nowrap font-label text-sm text-foreground-600">
            排序
          </label>
          <select
            id="sort-select"
            value={sort}
            onChange={(event) => onSortChange(event.target.value)}
            className="rounded-md border border-background-300 bg-background-50 px-3 py-2.5 font-label text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 cursor-pointer"
          >
            {SORTS.map((item) => (
              <option key={item.key} value={item.key}>
                {item.label}
              </option>
            ))}
          </select>
          <button
            type="submit"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            搜索
          </button>
        </div>
      </form>

      <div className="mt-4 flex gap-2 overflow-x-auto pb-1 no-scrollbar">
        {riskCategories.map((item) => {
          const active = category === item.key;
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onCategoryChange(item.key)}
              className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-2 font-label text-sm transition-colors cursor-pointer ${
                active
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              <i className={item.icon} />
              {item.name}
            </button>
          );
        })}
      </div>

      <div className="mt-4 flex flex-col gap-3 border-t border-background-200 pt-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="inline-flex items-center rounded-full bg-background-100 p-1">
          {LEVELS.map((item) => {
            const active = level === item.key;
            return (
              <button
                key={item.key}
                type="button"
                onClick={() => onLevelChange(item.key)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 font-label text-sm transition-colors cursor-pointer ${
                  active ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </div>
        <p className="font-label text-sm text-foreground-500">
          共找到 <span className="font-semibold text-foreground-900">{resultCount}</span> 条记录
        </p>
      </div>
    </div>
  );
}